import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import * as MaterialUI from 'material-ui';
import { push } from 'react-router-redux';
import FontAwesome from 'react-fontawesome';

import ItemListC from './itemList';
import * as vehiculosActions from 'modules/vehiculos/action';
import * as generalActions from 'modules/general/action';
import { EliminarConfirmacionC } from 'modules/general/component';

@connect(store => ({
  vehiculos: store.get('vehiculos'),
  userRoles: store.getIn(['user', 'roles']),
  eliminarId: store.getIn(['vehiculos', 'eliminarId']),
}))
export default class extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(generalActions.dashboard_changeTitle('VEHICULOS'));
    if (this.props.vehiculos.get('lista').size <= 1) this.props.dispatch(vehiculosActions.get());
  };
  add = () => this.props.dispatch(push('/dashboard/vehiculos/add/new'));
  delete = vehiculoId => this.props.dispatch(vehiculosActions.setState({ eliminarId: vehiculoId }));
  cancelarDelete = () => this.props.dispatch(vehiculosActions.setState({ eliminarId: false }));
  confirmDelete = () => {
    this.props.dispatch(vehiculosActions.delete_(this.props.eliminarId));
    this.cancelarDelete();
  };
  render = () => {
    const { eliminarId, userRoles } = this.props;
    return (
      <div>
        <Row className="rowContainer textCenter">
          <Col md={{ size: 10, offset: 1 }}>
            <MaterialUI.Paper zDepth={2} className="container">
              <MaterialUI.List className="noPadding dividerList">
                {this.props.vehiculos.get('lista').map(vehiculo => (
                  <div key={vehiculo.get('id')}>
                    <ItemListC vehiculo={vehiculo} />
                    <MaterialUI.Divider />
                  </div>
                ))}
              </MaterialUI.List>
            </MaterialUI.Paper>
          </Col>
        </Row>
        {userRoles && userRoles.find(v => v == 'admin' || v == 'devAdmin' || v == 'administrador_vehiculos') && (
          <MaterialUI.FloatingActionButton className="bottonFlotanteAdd" onTouchTap={this.add.bind(this)}>
            <FontAwesome name="plus" />
          </MaterialUI.FloatingActionButton>
        )}
        <EliminarConfirmacionC eliminarId={eliminarId} confirmar={this.confirmDelete} cancelar={this.cancelarDelete} />
      </div>
    );
  };
}



// WEBPACK FOOTER //
// src/modules/vehiculos/components/main.js